import { Interval } from './Interval';
import { createIntervalsInstance } from './Intervals';

export class TimeIntervalsController {
  constructor(intervals) {
    this.size = intervals?.length ?? 0;
    this._setIntervals(intervals);

    this.getTimesByDuration = this.getTimesByDuration.bind(this);
    this.createIsFromAvailableFn = this.createIsFromAvailableFn.bind(this);
    this.createIsToAvailableFn = this.createIsToAvailableFn.bind(this);
    this.createIntervals = this.createIntervals.bind(this);
    this.syncTimes = this.syncTimes.bind(this);
    this.syncTime = this.syncTime.bind(this);
    this.getIntervalById = this.getIntervalById.bind(this);
  }

  getIntervalById(id) {
    return this.allIntervals.get(id);
  }

  getTimesByDuration(duration, timeKey) {
    return this.groupedByDuration.get(duration)?.getTimes(timeKey);
  }

  // для классической настройки интервалов
  createIsFromAvailableFn({ duration, to, current }) {
    return this.groupedByDuration.has(duration)
      ? this.groupedByDuration
          .get(duration)
          .isFromAvailableCreator({ to, current })
      : () => true;
  }

  // для классической настройки интервалов
  createIsToAvailableFn({ duration, from, current }) {
    return this.groupedByDuration.has(duration)
      ? this.groupedByDuration
          .get(duration)
          .isToAvailableCreator({ from, current })
      : () => true;
  }

  // для по интервальной настройки интервалов
  createIsTimeAvailableFn({ duration, selectedIds }) {
    return this.groupedByDuration.has(duration)
      ? this.groupedByDuration.get(duration).isTimeAvailableCreator(selectedIds)
      : () => true;
  }

  // для классической настройки интервалов
  createIntervals({ duration, from, to, creator }) {
    return this.groupedByDuration
      .get(duration)
      ?.createIntervals({ from, to, creator });
  }

  // для классической настройки интервалов
  syncTimes({ duration, prevFrom, prevTo }) {
    return (
      this.groupedByDuration.get(duration)?.syncTimes({ prevFrom, prevTo }) ?? {
        from: null,
        to: null,
      }
    );
  }

  // для по интервальной настройки интервалов
  syncTime({ duration, prevTime, selectedIds }) {
    return (
      this.groupedByDuration
        .get(duration)
        ?.syncTime({ prevTime, selectedIds }) ?? null
    );
  }

  // для классической настройки интервалов
  addMissingIntervals({
    accumulator,
    currentInterval,
    nextIntervalId,
    adapter,
  }) {
    const intervals = this.groupedByDuration.get(currentInterval.duration);
    if (!intervals) return;

    intervals.addMissingIntervals({
      accumulator,
      currentInterval,
      nextIntervalId,
      adapter,
    });
  }

  _setIntervals(data = []) {
    const durationSet = new Set();
    this.groupedByDuration = new Map();
    this.allIntervals = new Map();

    data.forEach((i) => {
      const { duration } = i;

      durationSet.add(duration);

      const durationIntervals = getOrInsert(
        this.groupedByDuration,
        duration,
        createIntervalsInstance(duration, this.allIntervals)
      );

      const interval = new Interval(i);

      this.allIntervals.set(interval.id, interval);

      durationIntervals.add(interval);
    });

    this.durations = [...durationSet].sort((a, b) => a - b);
  }
}

function getOrInsert(map, key, defaultValue) {
  if (!map.has(key)) {
    map.set(key, defaultValue);
  }

  return map.get(key);
}
